export default __webpack_public_path__ + "static/media/pictogramBeaconUtilityWater64.2069f6f8.svg";